<template>
  <div v-loading="loading">
    <page-header title="Meetings" breadcrumb="CRM > Meetings" />

    <div class="card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-6">
            <div class="flex justify-between pt-12">
              <div>
                <p class="text-deepBlue font-semibold">
                  {{ currentDate }}
                </p>
              </div>
              <div>
                <p class="text-deepBlue font-semibold text-sm">
                  Schedule Meeting
                </p>
              </div>
            </div>
            <hr class="mt-2" />
            <div>
              <p class="font-semibold py-6">Today’s Schedules</p>

              <div class="container-fluid">
                <div class="row">
                  <div
                    class="col-12 col-md-6 col-lg-6 mt-4 cursor-pointer"
                    v-for="meeting in meetings"
                    :key="meeting.id"
                    @click="$router.push(`/crm/meetings/${meeting.id}`)"
                  >
                    <div class="meeting-card pl-2 py-2">
                      <p class="py-1 text-sm font-semibold">
                        {{ meeting.startTime }} - {{ meeting.endTime }}
                      </p>
                      <p class="py-1 font-semibold text-sm">
                        {{ meeting.description }}
                      </p>
                    </div>
                  </div>

                  <div v-if="!meetings.length">
                    No meetings found!
                  </div>
                </div>
              </div>
              <!-- <div class="meeting-cards"></div> -->
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-6 mt-8">
            <div class="pl-6">
              <Calendar class="rounded" style="background: #F3F6F9;" />
            </div>
          </div>
        </div>
      </div>

      <div class="mt-16">
        <primary-button
          buttonText="+ Schedule Meeting"
          @click="$router.push({ name: 'NewMeeting' })"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import Calendar from "./Calendar";

export default {
  components: {
    PageHeader,
    Calendar,
  },
  data() {
    return {
      meetings: [],
      loading: false,
    };
  },
  computed: {
    currentDate() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      let yyyy = today.getFullYear();

      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      // today = mm + "/" + dd + "/" + yyyy;
      today = `${dd} ${months[mm - 1]}, ${yyyy}`;
      return today;
    },
  },
  watch: {},
  mounted() {
    this.getAllMeetings();
  },
  methods: {
    async getAllMeetings() {
      this.loading = true;
      try {
        const response = await this.$_getAllMeetings();
        this.logResponse(response);
        this.meetings = response.data;
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.meeting-card {
  background: #ffffff;
  border: 0.2px solid #507fdf;
  border-radius: 3px;
  border-left: 5px solid #507fdf;
}
</style>
